/* eslint-disable @typescript-eslint/naming-convention */
import { ClientsResponse } from '@efex-services/client/types';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type Client = ClientsResponse['results'][0];

interface ViewClientDrawerProps {
  contact: Client;
}

const ViewClientDrawer = ({ contact }: ViewClientDrawerProps) => {
  const { t } = useTranslation();

  const {
    contactNaturalPersonEnterprise,
    enterpriseAddress,
    enterpriseBankAccount,
  } = contact || {};
  const { naturalPerson, enterprise } = contactNaturalPersonEnterprise || {};
  const { email, firstName, lastName, phoneNumber } = naturalPerson || {};
  const {
    country,
    countryData,
    entity_type,
    name: companyName,
    rfc,
  } = enterprise || {};
  const { city, state, postCode } = enterpriseAddress || {};
  const {
    accountNumber,
    bankName,
    clabe,
    routingNumber,
    swiftCode,
    accountCurrency,
  } = enterpriseBankAccount || {};
  return (
    <Box className="p-3 flex flex-col">
      <Box className="flex flex-row justify-between my-1">
        <Typography component="span" className="!font-bold">
          {t('clientName')}:
        </Typography>{' '}
        <Typography component="span">
          {firstName ?? ''} {lastName ?? ''}
        </Typography>
      </Box>
      {entity_type !== 'PERSON' && (
        <Box className="flex flex-row justify-between my-1">
          <Typography component="span" className="!font-bold">
            {t('companyName')}:
          </Typography>{' '}
          <Typography component="span">{companyName ?? ''}</Typography>
        </Box>
      )}
      {entity_type ? (
        <Box className="flex flex-row justify-between my-1">
          <Typography component="span" className="!font-bold">
            {t('typeOfBusiness')}:
          </Typography>{' '}
          <Typography component="span">
            {t(
              entity_type === 'COMPANY' ? 'ccEntityCompany' : 'ccEntityPerson'
            )}
          </Typography>
        </Box>
      ) : null}
      {bankName ? (
        <Box className="flex flex-row justify-between my-1">
          <Typography component="span" className="!font-bold">
            {t('bank')}:
          </Typography>{' '}
          <Typography component="span">{bankName}</Typography>
        </Box>
      ) : null}
      {accountNumber ? (
        <Box className="flex flex-row justify-between my-1">
          <Typography component="span" className="!font-bold">
            {t('ccAccountNumber')}:
          </Typography>{' '}
          <Typography component="span">{accountNumber}</Typography>
        </Box>
      ) : null}
      {routingNumber ? (
        <Box className="flex flex-row justify-between my-1">
          <Typography component="span" className="!font-bold">
            {t('ccRoutingNumber')}:
          </Typography>{' '}
          <Typography component="span">{routingNumber}</Typography>
        </Box>
      ) : null}
      {clabe ? (
        <Box className="flex flex-row justify-between my-1">
          <Typography component="span" className="!font-bold">
            {t('ccClabeNumber')}:
          </Typography>{' '}
          <Typography component="span">{clabe}</Typography>
        </Box>
      ) : null}
      {swiftCode ? (
        <Box className="flex flex-row justify-between my-1">
          <Typography component="span" className="!font-bold">
            {t('ccSwiftCode')}:
          </Typography>{' '}
          <Typography component="span">{swiftCode}</Typography>
        </Box>
      ) : null}
      {phoneNumber ? (
        <Box className="flex flex-row justify-between my-1">
          <Typography component="span" className="!font-bold">
            {t('regPhone')}:
          </Typography>{' '}
          <Typography component="span">{phoneNumber}</Typography>
        </Box>
      ) : null}
      {email ? (
        <Box className="flex flex-row justify-between my-1">
          <Typography component="span" className="!font-bold">
            {t('email')}:
          </Typography>{' '}
          <Typography component="span">{email}</Typography>
        </Box>
      ) : null}
      {country || countryData ? (
        <Box className="flex flex-row justify-between my-1">
          <Typography component="span" className="!font-bold">
            {t('country')}:
          </Typography>{' '}
          <Typography component="span">
            {countryData?.name ?? country}
          </Typography>
        </Box>
      ) : null}
      {city ? (
        <Box className="flex flex-row justify-between my-1">
          <Typography component="span" className="!font-bold">
            {t('city')}:
          </Typography>{' '}
          <Typography component="span">{city}</Typography>
        </Box>
      ) : null}
      {state ? (
        <Box className="flex flex-row justify-between my-1">
          <Typography component="span" className="!font-bold">
            {t('state')}:
          </Typography>{' '}
          <Typography component="span">{state}</Typography>
        </Box>
      ) : null}
      {postCode ? (
        <Box className="flex flex-row justify-between my-1">
          <Typography component="span" className="!font-bold">
            {t('postCode')}:
          </Typography>{' '}
          <Typography component="span">{postCode}</Typography>
        </Box>
      ) : null}
      {rfc ? (
        <Box className="flex flex-row justify-between my-1">
          <Typography component="span" className="!font-bold">
            {t('rfc')}:
          </Typography>{' '}
          <Typography component="span">{rfc}</Typography>
        </Box>
      ) : null}
      {accountCurrency ? (
        <Box className="flex flex-row justify-between my-1">
          <Typography component="span" className="!font-bold">
            {t('ccAccountCurrencyType')}:
          </Typography>{' '}
          <Typography component="span">{accountCurrency}</Typography>
        </Box>
      ) : null}
    </Box>
  );
};

export default ViewClientDrawer;
